<template>
    <div
        id="myLotsSelect"
        :class="{
            'select-all-support': multiple && selectAll
        }"
    >
        <el-select
            :placeholder="placeholder"
            v-model="value"
            @clear="clear(value)"
            :multiple="multiple"
            :multiple-limit="multipleLimit"
            :collapse-tags="collapseTags"
            :filterable="filterable"
            @change="sendSelectValue"
            :disabled="disabled"
            clearable
        >
            <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
            ></el-option>
        </el-select>
        <!-- 全选按钮 -->
        <el-button
            v-if="multiple && selectAll"
            :disabled="disabled"
            @click="selectAllValue"
            :type="isSelectedAll() && value.length != 0 ? 'primary' : 'default'"
        >
            全选
        </el-button>
    </div>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api';
import lodash from 'lodash';
export default {
    data() {
        return {
            options: [],
            value: ''
        };
    },
    props: {
        url: String,
        optionArr: Array,
        optionNum: String,
        placeholder: String,
        prop: String,
        propName: String,
        multiple: Boolean,
        mValue: [String, Number, Array],
        disabled: {
            type: Boolean,
            default: false
        },
        selectAll: {
            type: Boolean,
            default: false
        },
        filterable: Boolean,
        collapseTags: {
            type: Boolean,
            default: false
        },
        multipleLimit: {
            type: Number,
            default: 0
        },
        disabledOptions: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    watch: {
        optionArr(val) {
            this.options = val;
        },
        mValue(val) {
            this.value = val;
        },
        optionNum(val) {
            this.getDictionary(val);
        },
        disabledOptions(val) {
            this.options = this.filterDisabledOptions(this.options);
        }
    },
    methods: {
        /**
         * 是否全选状态
         */
        isSelectedAll() {
            const selectableValue = this.options.filter(item => !item.disabled).map(item => item.value);
            return lodash.intersection(this.value, selectableValue).length === selectableValue.length;
        },
        /**
         * 全选或反选
         */
        selectAllValue() {
            if (this.isSelectedAll()) {
                this.value = []
            } else {
                this.value = this.options.filter(item => !item.disabled).map(item => item.value);
            }
            this.sendSelectValue();
        },
        filterDisabledOptions(options) {
            options = options.map(item => {
                item.disabled = this.disabledOptions.includes(item.value);
                return item;
            });
            return options;
        },
        getDictionary(optionNum = null) {
            const params = optionNum || this.optionNum;
            if (params) {
                dictWithUrl(params, this.url).then(res => {
                    if (res.code === '0') {
                        const arr = [];
                        for (const key in res.data[params]) {
                            if (res.data[params].hasOwnProperty(key)) {
                                arr.push({
                                    value: key,
                                    label: res.data[params][key]
                                });
                            }
                        }
                        this.options = this.filterDisabledOptions(arr);
                    }
                });
            } else {
                this.options = this.filterDisabledOptions(this.optionArr);
            }
        },
        sendSelectValue() {
            const data = {};
            data[this.prop] = this.value;
            let label = '';
            this.options.map(item => {
                if (item.value === this.value) {
                    label = item.label;
                }
            });
            // 多选抛出中文label
            if (this.multiple) {
                const names = {};
                let multipLabel = [];
                this.options.map(item => {
                    this.value.forEach((e, index) => {
                        if (item.value === e) {
                            // 取下标保证顺序的一致性
                            multipLabel[index] = item.label;
                        }
                    });
                });
                if (this.propName) {
                    names[this.propName] = multipLabel;
                }
                this.$emit('getSelectmultipValue', data, names);
            }
            this.$emit('getSelectValue', data, label);
            setTimeout(() => {
                this.$emit('change');
            }, 50);
        },
        clear(value) {
            this.$emit('clear', this.value);
        }
    },
    created() {
        this.getDictionary();
        this.value = this.mValue;
    }
};
</script>

<style lang="less">
#myLotsSelect {
    width: 100%;

    .el-select {
        width: 100%;
    }

    &.select-all-support {
        display: flex;

        .el-select {
            display: flex;
        }

        .el-select__tags {
            flex-wrap: nowrap;
            overflow: hidden;
        }

        // 第一个左侧有圆角，最后一个右侧有圆角
        :first-child {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 4px;
            border-top-left-radius: 4px;
        }

        :last-child {
            // border-radius: 0;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
        }

        // 其它没有圆角
        :not(:first-child):not(:last-child) {
            border-radius: 0;
        }
    }
}
</style>
